import { FlexBox } from 'src/ui/common/atoms/flex-box';
import styled from 'styled-components';

export const StyledDateTimeDisplayWrapper = styled(FlexBox)`
    flex-direction: column;
`;

export const StyledValue = styled.div`
    font-family: ${({ theme }) => theme.fonts.title};
    font-size: 24px;
    font-weight: 800;
    color: ${({ theme }) => theme.colors.white};
`;

export const StyledLabel = styled.div`
    font-family: ${({ theme }) => theme.fonts.text};
    font-weight: 400;
    font-size: 10px;
    text-align: center;
    color: ${({ theme }) => theme.colors.gs200};
`;
